<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content>
    <div class="project-page d-flex align-items-center gap-3 mb-4">
        <form [formGroup]="form" class="filters d-flex align-items-center gap-3 flex-wrap">
            <mat-form-field appearance="fill" class="filters-form-field">
                <mat-label>Project name</mat-label>
                <mat-icon matPrefix class="me-1">folder</mat-icon>
                <input matInput formControlName="name" />
            </mat-form-field>

            <select-list #selectListClients [optionList]="optionsFromClients" [searchBar]="true" label="Client" icon="business" (selectedOptionChanged)="form.get('client')?.setValue($event)" />

            <select-list #selectListMembers [optionList]="optionsFromMembers" [multiple]="true" [searchBar]="true" label="Members" icon="group" (selectedOptionsChanged)="form.get('members')?.setValue($event)" />

            <mat-form-field>
                <input matInput matNativeControl type="number" formControlName="budget" />
            </mat-form-field>

            <mat-form-field>
                <input matInput matNativeControl type="color" formControlName="color" />
            </mat-form-field>

            <div class="d-flex align-items-center gap-3 ms-2">
                <mat-checkbox formControlName="active" class="small">
                    Active
                </mat-checkbox>
                <mat-checkbox formControlName="archived" class="small">
                    Archived
                </mat-checkbox>
            </div>

        </form>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-button mat-dialog-close cdkFocusInitial (click)="projectSubmit()">{{submitButton}}</button>
</mat-dialog-actions>
